import { render } from "./DashboardVideo.vue?vue&type=template&id=0c4bbe5d"
import script from "./DashboardVideo.vue?vue&type=script&lang=js"
export * from "./DashboardVideo.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\urbanquater-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__